import { defineMessages } from 'react-intl';

export default defineMessages({
    noInfo: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.noInfo',
        defaultMessage: 'No information is available to display'
    },
    pfmReport: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.Personal Financial Management Report',
        defaultMessage: 'Personal Financial Management Report'
    },
    insuranceScore: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.Insurance Score',
        defaultMessage: 'Insurance Score'
    },
    NAME: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.NAME',
        defaultMessage: 'NAME'
    },
    GENERATED: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.GENERATED #',
        defaultMessage: 'GENERATED #'
    },
    LEVEL: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.LEVEL',
        defaultMessage: 'LEVEL'
    },
    DATE_ORDERED: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.DATE ORDERED',
        defaultMessage: 'DATE ORDERED'
    },
    REASONS: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.REASONS',
        defaultMessage: 'REASONS'
    },
    REPORTSTATUS: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.REPORT STATUS',
        defaultMessage: 'REPORT STATUS'
    },
    SOURCE: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.SOURCE',
        defaultMessage: 'SOURCE'
    },
    RATING: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.RATING',
        defaultMessage: 'RATING'
    },
    RATINGLEVEL: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.RATING LEVEL',
        defaultMessage: 'RATING LEVEL'
    },
    priorLosses: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.Prior Losses',
        defaultMessage: 'Prior Losses'
    },
    ORDER_DATE: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.ORDER DATE',
        defaultMessage: 'ORDER DATE'
    },
    CLAIM_DATE: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.CLAIM DATE',
        defaultMessage: 'CLAIM DATE'
    },
    TOTAL_AMT_PAID: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.TOTAL AMOUNT PAID',
        defaultMessage: 'TOTAL AMOUNT PAID'
    },
    VEHICLE_OPERATOR: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.VEHICLE OPERATOR',
        defaultMessage: 'VEHICLE OPERATOR'
    },
    FAULT: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.FAULT',
        defaultMessage: 'FAULT'
    },
    DESCRIPTION: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.DESCRIPTION',
        defaultMessage: 'DESCRIPTION'
    },
    INSURED_LOSS: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.INSURED LOSS',
        defaultMessage: 'INSURED LOSS'
    },
    TYPE_OF_LOSS: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.TYPE OF LOSS',
        defaultMessage: 'TYPE OF LOSS'
    },
    LOB: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.LOB',
        defaultMessage: 'LOB'
    },
    AMT_PAID: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.AMT PAID',
        defaultMessage: 'AMT PAID'
    },
    ACT_OF_GOD: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.ACT OF GOD',
        defaultMessage: 'ACT OF GOD'
    },
    CAT: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.CAT',
        defaultMessage: 'CAT'
    },
    mvrReport: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.Motor Vehicle Report',
        defaultMessage: 'Motor Vehicle Report'
    },
    GENDER: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.GENDER',
        defaultMessage: 'GENDER'
    },
    DATE_OF_BIRTH: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.DATE OF BIRTH',
        defaultMessage: 'DATE OF BIRTH'
    },
    STATE: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.STATE',
        defaultMessage: 'STATE'
    },
    LICENSE_STATUS: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.LICENSE STATUS',
        defaultMessage: 'LICENSE STATUS'
    },
    VIOLATIONS: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.VIOLATIONS',
        defaultMessage: 'VIOLATIONS'
    },
    DATE_OF_INCIDENT: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.DATE OF INCIDENT',
        defaultMessage: 'DATE OF INCIDENT'
    },
    CONVICTION_DATE: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.CONVICTION DATE',
        defaultMessage: 'CONVICTION DATE'
    },
    INCIDENT_TYPE: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.INCIDENT TYPE',
        defaultMessage: 'INCIDENT TYPE'
    },
    claimDetails: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.Claim Details',
        defaultMessage: 'Claim Details'
    },
    driversName: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.Drivers Name',
        defaultMessage: 'Drivers Name'
    },
    dateOfBirth: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.Date of Birth',
        defaultMessage: 'Date of Birth'
    },
    gender: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.Gender',
        defaultMessage: 'Gender'
    },
    licenseNumber: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.License #',
        defaultMessage: 'License Number'
    },
    licenseState: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.License State',
        defaultMessage: 'License State'
    },
    year: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.Year',
        defaultMessage: 'Year'
    },
    make: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.Make',
        defaultMessage: 'Make'
    },
    model: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.Model',
        defaultMessage: 'Model'
    },
    vin: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.Vehicle Identification Number',
        defaultMessage: 'Vehicle Identification Number'
    },
    vehicleDisposition: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.Vehicle Disposition',
        defaultMessage: 'Vehicle Disposition'
    },
    name: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.Name',
        defaultMessage: 'Name'
    },
    description: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.Description',
        defaultMessage: 'Description'
    },
    actOfGod: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.Act of God',
        defaultMessage: 'Act of God'
    },
    catIndicator: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.CAT Indicator',
        defaultMessage: 'CAT Indicator'
    },
    COVERAGE_TYPE: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.COVERAGE TYPE',
        defaultMessage: 'COVERAGE TYPE'
    },
    AMOUNT_PAID: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.AMOUNT PAID',
        defaultMessage: 'AMOUNT PAID'
    },
    STATUS: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.STATUS',
        defaultMessage: 'STATUS'
    },
    close: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.Close',
        defaultMessage: 'Close'
    },
    POINTS: {
        id: 'ml.gateway.quoteandbind.common.mlRatingFactorConsumerReports.POINTS',
        defaultMessage: 'POINTS'
    }
});